import { EventTrack } from '@angularticsCompat';
import { Activation } from './models/activation';
import {
  TRACKER_ACTIVATION_TEST_QUERY_CLICK,
  TRACKER_ACTIVATION_TEST_QUERY_FAILED,
  TRACKER_ACTIVATION_TEST_QUERY_SUCCESS
} from './tracking';
import { QueryExecutionResponse, QueryExecutionStatusEnum } from '../../warehouse-management/workbench/interfaces/workbench';
import useAnalyticsTracker from '../../analytics/hooks/useAnalyticsTracker';

const queryExecutionExpectedStatus = [
  QueryExecutionStatusEnum.SUCCESS,
  QueryExecutionStatusEnum.FAILED,
  QueryExecutionStatusEnum.REQUEST_ID
]

export function useTrackActivationQueryExecutionStatus() {
  const { eventTrack } = useAnalyticsTracker();

  const trackQueryExecutionStatus = (response: QueryExecutionResponse, activation: Activation) => {
    if (!queryExecutionExpectedStatus.includes(response.status)) {
      return;
    }

    let angularticsEventObj: EventTrack;

    if (response.status === QueryExecutionStatusEnum.REQUEST_ID) {
      angularticsEventObj = {
        action: TRACKER_ACTIVATION_TEST_QUERY_CLICK,
        properties: {}
      };

    } else if (response.status === QueryExecutionStatusEnum.SUCCESS) {
      angularticsEventObj = {
        action: TRACKER_ACTIVATION_TEST_QUERY_SUCCESS,
        properties: {}
      };

    } else if (response.status === QueryExecutionStatusEnum.FAILED) {
      angularticsEventObj = {
        action: TRACKER_ACTIVATION_TEST_QUERY_FAILED,
        properties: {
          failureMessage: response.error
        }
      };
    }

    angularticsEventObj.properties = {
      ...angularticsEventObj.properties,
      activationName: activation?.name,
      destinationType: activation?.warehouse?.warehouseType,
      destinationName: activation?.warehouse?.name
    };

    eventTrack(angularticsEventObj);
  };

  return {
    trackQueryExecutionStatus
  };
}
